import React from "react";
import { NavLink } from "react-router-dom";

const ManageProduct = ({product, handleDeleteProduct}) => {
  const { price, availableQty, minimumOrderQty, picture} = product;


  return (
    <>
      <tbody>
        <tr>
          <td>
            <img style={{width: "30px"}} src={picture} alt="" />
          </td>
          <td>${price} </td>
          <td>{availableQty} pcs</td>
          <td>{minimumOrderQty} </td>
          <td>
          <NavLink to="/dashboard/updateproduct" >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
            </NavLink>
          </td>
          <td>
          <NavLink to="/dashboard/addnewproduct" >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4v16m8-8H4"
              />
            </svg>
            </NavLink>
          </td>
          <td className="cursor-pointer">
            
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              onClick={() => handleDeleteProduct(product._id)}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </>
  );
};

export default ManageProduct;
